// Bespoke client for the RBAC roles API (/api/roles). Hand-written (not generated) so it lives
// beside its consumer — `src/API/` is wiped by `npm run swagger`. Goes through the shared axios
// instance so the Auth0AxiosBridge attaches the admin token.
import axios from "axios";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface Role {
	key: string;
	name: string;
	description?: string | null;
	permissions: string[];
	isSystem: boolean;
	userCount: number;
	createdAt: string;
	updatedAt: string;
}

export interface RoleInput {
	name: string;
	description?: string | null;
	permissions: string[];
}

export const rolesClient = {
	async list(): Promise<Role[]> {
		const r = await axios.get<Role[]>(`${apiBase}/api/roles`, { withCredentials: true });
		return r.data ?? [];
	},
	async create(key: string, body: RoleInput): Promise<Role> {
		const r = await axios.post<Role>(`${apiBase}/api/roles/${encodeURIComponent(key)}`, body, { withCredentials: true });
		return r.data;
	},
	async update(key: string, body: RoleInput): Promise<Role> {
		const r = await axios.put<Role>(`${apiBase}/api/roles/${encodeURIComponent(key)}`, body, { withCredentials: true });
		return r.data;
	},
	async remove(key: string): Promise<void> {
		await axios.delete(`${apiBase}/api/roles/${encodeURIComponent(key)}`, { withCredentials: true });
	}
};
